import type { SVGProps } from 'react';

/**
 * CollapseAllIcon — vendored Octicon "fold" glyph, 16px (ADR B6a).
 *
 * See `ExpandAllIcon.tsx` for the full rationale: this is the second half of
 * Treeview's Expand-all / Collapse-all pair
 * (`packages/treeview/src/components/filterable-tree/TreeWithDetailsView.tsx:3,746-767`),
 * vendored rather than imported for the same reason — `@primer/octicons-react`
 * is not an mm-web dependency and treeview cannot be imported across the
 * package boundary. Same wrapper shape as `components_misc/CollapseIcon.tsx`
 * / `ExpandIcon.tsx`.
 *
 * Source: `@primer/octicons-react@19.15.2` (the version `packages/treeview`
 * pins), glyph name `fold`, 16px variant, path data verbatim. MIT licensed
 * (Copyright (c) GitHub Inc., https://github.com/primer/octicons).
 */
export function CollapseAllIcon({
  className = '',
  'aria-hidden': ariaHidden = true,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="currentColor"
      className={className}
      aria-hidden={ariaHidden}
      {...props}
    >
      <path d="M10.896 2H8.75V.75a.75.75 0 0 0-1.5 0V2H5.104a.25.25 0 0 0-.177.427l2.896 2.896a.25.25 0 0 0 .354 0l2.896-2.896A.25.25 0 0 0 10.896 2ZM8.75 15.25a.75.75 0 0 1-1.5 0V14H5.104a.25.25 0 0 1-.177-.427l2.896-2.896a.25.25 0 0 1 .354 0l2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25Zm-6.5-6.5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z" />
    </svg>
  );
}
